import {createSlice} from "../../../__snowpack__/pkg/@reduxjs/toolkit.js";
export const INITIAL_STATE = {
  whiteLabel: {},
  account: {}
};
export const filtersStore = createSlice({
  name: "filtersStore",
  initialState: INITIAL_STATE,
  reducers: {
    resetFilters: () => INITIAL_STATE,
    setWhiteLabelFilters: (state, action) => ({
      ...state,
      whiteLabel: {
        ...state.whiteLabel,
        ...action.payload
      }
    }),
    resetWhiteLabelFilters: (state) => ({
      ...state,
      whiteLabel: {}
    }),
    setAccountFilters: (state, action) => ({
      ...state,
      account: {
        ...state.account,
        ...action.payload
      }
    }),
    resetAccountFilters: (state) => ({
      ...state,
      account: {}
    })
  }
});
export default filtersStore.reducer;
